<template>
  <div>
    <ExpandableSettingsItem :title="$t('message.GW_DEFAULT_TICK_TEAMS_TITLE')">
      <div>
        <div class="field-hint">
          {{ $t('message.GW_DEFAULT_TICK_TEAMS_HINT') }}
        </div>
        <IntCheckbox
          v-model="currentTeam.gwEndTickTeams"
          :title="$t('message.GW_DEFAULT_TICK_TEAMS')"
          @input="setParams('gwEndTickTeams', $event)"
        />
      </div>
    </ExpandableSettingsItem>
    <ExpandableSettingsItem :title="$t('message.DISPLAY_NOUN')">
      <div>
        <div class="field-hint">
          {{ $t('message.GW_DEFAULT_HIDE_PREVIOUS_HINT') }}
        </div>
        <IntCheckbox
          v-model="currentTeam.gwHidePreviousData"
          :title="$t('message.GW_DEFAULT_HIDE_PREVIOUS')"
          @input="setParams('gwHidePreviousData', $event)"
        />
      </div>
    </ExpandableSettingsItem>
    <ExpandableSettingsItem :title="$t('message.GW_OVERLAY')">
      <div class="setting-content">
        <IntCheckbox
          v-model="currentTeam.gwHideOverlay"
          :title="$t('message.HIDE_GW_OVERLAY')"
          @input="onClickHideOverlay"
        />
        <!-- Ignore until next GW feature -->
        <!--button class="action-btn" @click="onClickOverlayReset">
          {{ $t('message.RESET_GW_OVERLAY') }}
        </button-->
      </div>
    </ExpandableSettingsItem>
  </div>
</template>

<script>
/**
 * Main settings page for GW
 */
import toastr from 'toastr';
// Import components
import ExpandableSettingsItem from '@/components/expandable-settings-item.vue';
import IntCheckbox from '@/components/int-checkbox.vue';
// Import store utils
import { SET_TEAM_PARAM } from '@/store/action-types';
import { SET_GW_OVERLAY_VISIBILITY, SET_GW_OVERLAY_LAST_DATE } from '@/store/mutation-types';

export default {

  name: 'ConfigurablePages',

  components: {
    ExpandableSettingsItem,
    IntCheckbox,
  },

  data() {
    return {
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.GW_MENU'),
    };
  },

  methods: {
    /** Team params edited */
    setParams(field, val) {
      this.$store.dispatch(SET_TEAM_PARAM, { [field]: val });
    },
    onClickHideOverlay(e) {
      this.$store.commit(SET_GW_OVERLAY_VISIBILITY, true);
      this.setParams('gwHideOverlay', e);
    },
    onClickOverlayReset() {
      this.$store.commit(SET_GW_OVERLAY_VISIBILITY, true);
      this.$store.commit(SET_GW_OVERLAY_LAST_DATE, 0);
      toastr.success(this.$t('message.SETTING_SAVED'));
    },
  },
};
</script>
